// import { medusaClient } from "@lib/config"
import { StoreRegion } from "@/types/store"
import { cache } from "react"
import { fetch } from "@lib/util/fetch"

const BACKEND_URL = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL
const PUBLISHABLE_API_KEY = process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY

export const listRegions = cache(async function () {
  try {
    const response = await fetch(`${BACKEND_URL}/store/store-regions`, {
      headers: {
        "x-publishable-api-key": PUBLISHABLE_API_KEY!,
      },
      next: {
        revalidate: 3600,
        tags: ["regions"],
      },
    })

    // Handle rate limiting gracefully - return empty array instead of throwing
    if (!response.ok) {
      if (response.status === 429) {
        console.warn("Rate limit detected in listRegions, returning empty array")
        return []
      }
      throw new Error(`Failed to fetch regions: ${response.status} ${response.statusText}`)
    }

    const data = await response.json()
    return data?.region?.[0] || []
  } catch (error: any) {
    // Check if it's a rate limit error and handle gracefully
    if (error?.isRateLimit || error?.status === 429) {
      console.warn("Rate limit error in listRegions, returning empty array")
      return []
    }
    console.error("Error in listRegions:", error)
    return []
  }
})

// export const retrieveRegion = cache(async function (id: string) {
//   return medusaClient.store.region
//     .retrieve(id, {}, { next: { tags: ["regions"] } })
//     .then(({ region }) => {
//       console.log(`retrieveRegion response for ${id}:`, region) // Log response here
//       return region
//     })
//     .catch((error) => {
//       console.error(`Error in retrieveRegion for ${id}:`, error)
//       return Error(error)
//     })
// })

export const getRegion = cache(async function () {
  try {
    const regionData = await listRegions()

    // If regions list is empty or invalid, return null
    if (!regionData || Object.keys(regionData).length === 0 || !regionData.countries) {
      console.warn("[getRegion] No valid region found.");
      return null
    }

    // We always return the default/first available region.
    return regionData
  } catch (e: any) {
    console.error("Error in getRegion:", e)
    return null
  }
})